<template>
    <transition>
        <div class="modal">
            <div class="success" v-if="isSent">
                <img src="@/assets/images/email.webp" alt="" />
                <h1 class="title">Email Sent!</h1>
                <p>
                    Thank you for reaching out!!! I’ll get back to you as soon
                    as possible
                </p>
            </div>
            <div class="inner-modal">
                <ion-icon
                    name="close-circle-outline"
                    class="close"
                    @click="$emit('closeModal')"
                ></ion-icon>
                <h1>HIRE ME!</h1>
                <input
                    class="_input"
                    type="text"
                    placeholder="Enter your Email"
                    v-model="email"
                    :class="{
                        error: (isEmailClicked && !email) || !isEmail,
                    }"
                    @click="isEmailClicked = true"
                />
                <p v-if="!isEmail && email" class="error_p">
                    Please Enter a valid email
                </p>
                <p v-if="!email && isEmailClicked" class="error_p">
                    Email is required
                </p>
                <input
                    class="_input"
                    type="text"
                    placeholder="Enter your Name/Company"
                    v-model="name"
                    :class="{
                        error: isNameClicked && !name,
                    }"
                    @click="isNameClicked = true"
                />
                <p v-if="!name && isNameClicked" class="error_p">
                    Name is required
                </p>
                <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    placeholder="send a message"
                    v-model="msg"
                    :class="{
                        error: isMsgClicked && !msg,
                    }"
                    @click="isMsgClicked = true"
                ></textarea>
                <p v-if="!msg && isMsgClicked" class="error_p">
                    Message is required
                </p>
                <div
                    class="btn"
                    @click.prevent="submit"
                    :class="{ isDisable: !isDisable }"
                >
                    <div class="lds-ripple" v-if="loader">
                        <div></div>
                        <div></div>
                    </div>
                    <div v-if="!loader">Email Me!</div>
                </div>
                <div class="or">
                    <div class="line"></div>
                    <span>or</span>
                    <div class="line"></div>
                </div>
                <div class="contacts">+639532244832</div>
                <div class="contacts">golimrio14@gmail.com</div>
            </div>
        </div>
    </transition>
</template>

<script>
import { computed, ref, watch } from "vue";
import emailjs from "@emailjs/browser";
export default {
    setup() {
        const name = ref("");
        const email = ref("");
        const msg = ref("");
        const isEmail = ref(true);
        const isEmailClicked = ref(false);
        const isNameClicked = ref(false);
        const isMsgClicked = ref(false);
        const isSent = ref(false);
        const loader = ref(false);
        const submit = () => {
            if(!isDisable.value) return; 
            loader.value = true; 
            emailjs
                .send(
                    "service_btie3sd",
                    "template_4ssaff7",
                    {
                        from_name: name.value,
                        message: msg.value,
                        from_email: email.value,
                    },
                    "7vM6ZDyzJHRoRWeH3"
                )
                .then((res) => {
                    if (res.status == 200 && res.text == "OK") {
                        isSent.value = true;
                        loader.value = false; 
                        console.log("SUCCESS!", res.status, res.text);
                        setTimeout(() => {
                            isSent.value = false;
                        }, 4000);
                        name.value = "";
                        msg.value = "";
                        email.value = "";
                        isEmailClicked.value = false; 
                        isMsgClicked.value = false; 
                        isNameClicked.value = false;
                        isEmail.value = true; 
                    }else{
                        console.log("error!", res); 
                    }
                });
        };
        const validateEmail = (email) => {
            if (/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                isEmail.value = true;
            } else {
                isEmail.value = false;
            }
        };
        watch(email, (new_value) => {
            if(!new_value) return;
            validateEmail(new_value);
        });
        const isDisable = computed(() => {
            if (isEmail.value && name.value && msg.value) {
                return true;
            }
            return false;
        });

        return {
            name,
            email,
            msg,
            submit,
            isEmail,
            isEmailClicked,
            isMsgClicked,
            isNameClicked,
            isDisable,
            isSent,
            loader,
        };
    },
};
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
.modal {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;

    .success {
        width: 300px;
        height: 145px;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -300%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        border-bottom: 3px solid #16a085;
        color: #04293a;
        .title {
            color: #04293a;
            font-size: 20px;
        }
        p {
            font-size: 15px;
            text-align: center;
        }
    }
    .inner-modal {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 375px;
        height: 500px;
        background: #fff;
        border-radius: 10px;
        border: 4px solid #ecb365;

        .close {
            color: #ecb365;
            font-size: 40px;
            position: absolute;
            top: -40px;
            right: -40px;
            cursor: pointer;
        }
        h1 {
            font-size: 40px;
            color: #ecb365;
            margin-bottom: 25px;
        }
        ._input {
            border: none;
            border-bottom: 2px solid #ecb365;
            padding: 5px;
            width: 210px;
            margin-bottom: 20px;
            color: #000;
            &:focus {
                outline: none;
            }
            &::placeholder {
                font-family: "Poppins", sans-serif;
            }
        }
        .error {
            margin-bottom: 0;
            border-color: #b92b27;
        }
        .error_p {
            color: #b92b27;
            font-size: 12px;
            margin: 5px 0;
        }

        textarea {
            border: 2px solid #ecb365;
            border-radius: 5px;
            resize: none;
            padding: 10px;
            &:focus {
                outline: none;
            }
            &::placeholder {
                font-family: "Poppins", sans-serif;
            }
        }
        .btn {
            cursor: pointer;
            width: 110px;
            height: 30px;
            background: #ecb365;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            margin-bottom: 12px;
            font-size: 12px;
            border-radius: 5px;
            font-weight: lighter;
        }
        .isDisable {
            background: #4b4c4e;
            cursor: not-allowed;
        }
        .or {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 11px;
            .line {
                width: 90px;
                background: #e5e5e5;
                height: 1px;
            }
            span {
                font-size: 12px;
                color: #7f868c;
            }
        }
        .contacts {
            color: #ecb365;
            font-size: 12px;
        }
    }
}
</style>
